import React, { useState, useEffect } from 'react'
import PromptEdit from '../../Components/Claude/PromptEdit'
import axios from 'axios'
import {
  STIPOP_API_HOST,
  STIPOP_API_KEY,
} from '../../_Components/Common/common'

const ClaudePrompt = ({ match, location }) => {
  const [model, setModel] = useState('claude-3-5-sonnet-20240620')
  const [devData, setDevData] = useState({})
  const [data, setData] = useState({})
  const [modelList, setModelList] = useState(null)

  useEffect(() => {
    getModelList()
  }, [])

  const getModelList = async () => {
    await axios
      .get(`${STIPOP_API_HOST}/v4/message/claude/model`, {
        headers: {
          apikey: STIPOP_API_KEY,
        },
      })
      .then(({ data }) => {
        setModelList(data.body)
      })
      .catch(err => {
        console.error(err)
      })
  }

  const getClaudePrompt = async () => {
    await axios
      .get(`${STIPOP_API_HOST}/v4/message/claude/prompt/${model}?isdev=Y`, {
        headers: {
          apikey: STIPOP_API_KEY,
        },
      })
      .then(({ data }) => {
        setDevData(data.body)
      })

    await axios
      .get(`${STIPOP_API_HOST}/v4/message/claude/prompt/${model}`, {
        headers: {
          apikey: STIPOP_API_KEY,
        },
      })
      .then(({ data }) => {
        setData(data.body)
      })
  }

  const updateClaudePrompt = (id, prompt) => {
    axios
      .put(
        `${STIPOP_API_HOST}/v4/message/claude/prompt/${id}`,
        {
          prompt,
        },
        {
          headers: {
            apikey: STIPOP_API_KEY,
          },
        }
      )
      .then(() => {
        getClaudePrompt()
      })
  }

  const updateDevClaudePrompt = (id, prompt) => {
    axios
      .put(
        `${STIPOP_API_HOST}/v4/message/claude/prompt/${id}?isdev=Y`,
        {
          prompt,
        },
        {
          headers: {
            apikey: STIPOP_API_KEY,
          },
        }
      )
      .then(() => {
        getClaudePrompt()
      })
  }

  useEffect(() => {
    getClaudePrompt()
  }, [model])

  return (
    <React.Fragment>
      <PromptEdit
        model={model}
        modelList={modelList}
        setModel={setModel}
        data={data}
        setData={setData}
        devData={devData}
        setDevData={setDevData}
        updateClaudePrompt={updateClaudePrompt}
        updateDevClaudePrompt={updateDevClaudePrompt}
      />
    </React.Fragment>
  )
}

export default ClaudePrompt
